/**
 * Enum of values for each OutfileFileMimeType
 * @see OutfileFileMimeType
 */
export var OutfileFileMimeTypes;
(function (OutfileFileMimeTypes) {
    OutfileFileMimeTypes["stla"] = "application/sla";
    OutfileFileMimeTypes["stlb"] = "application/sla";
    OutfileFileMimeTypes["amf"] = "application/amf+xml";
    OutfileFileMimeTypes["x3d"] = "model/x3d+xml";
    OutfileFileMimeTypes["dxf"] = "application/dxf";
    OutfileFileMimeTypes["jscad"] = "application/javascript";
    OutfileFileMimeTypes["js"] = "application/javascript";
})(OutfileFileMimeTypes || (OutfileFileMimeTypes = {}));
/**
 * An enum of values for each `ExportFormat`
 * @see ExportFormat
 */
export var ExportFormats;
(function (ExportFormats) {
    ExportFormats["stla"] = "stla";
    ExportFormats["stlb"] = "stlb";
    ExportFormats["amf"] = "amf";
    ExportFormats["x3d"] = "x3d";
    ExportFormats["dxf"] = "dxf";
    ExportFormats["jscad"] = "jscad";
    ExportFormats["js"] = "js";
})(ExportFormats || (ExportFormats = {}));
/**
 * Enum of values in `ProcessorState`
 * @see ProcessorState
 */
export var ProcessorStates;
(function (ProcessorStates) {
    ProcessorStates["empty"] = "empty";
    ProcessorStates["aborted"] = "aborted";
    ProcessorStates["ready"] = "ready";
    ProcessorStates["rendering"] = "rendering";
    ProcessorStates["error"] = "error";
})(ProcessorStates || (ProcessorStates = {}));
//# sourceMappingURL=types.js.map